document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.btn_select_options');

    function handleButtonClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const quickAddParent = button.closest('.quick-add');
        if (quickAddParent) {
            const productOptionsContainer = quickAddParent.querySelector('.product_options__container');
            const quickAddSubmitButton = quickAddParent.querySelector('.quick-add__submit');
            if (productOptionsContainer) {
                productOptionsContainer.classList.add('active');
                const firstInput = productOptionsContainer.querySelector('input[type="radio"]');
                if (firstInput) {
                    firstInput.click();
                }
                // Calculate and set the top position based on the height
                const containerHeight = productOptionsContainer.offsetHeight;
                productOptionsContainer.style.top = `-${containerHeight + 30}px`; // Restar 20px
            }
            if (quickAddSubmitButton && quickAddSubmitButton.classList.contains('btn_select_options')) {
                quickAddSubmitButton.classList.remove('btn_select_options');
                quickAddSubmitButton.removeEventListener('click', handleButtonClick);
            }
        }
    }

    buttons.forEach(button => {
        button.addEventListener('click', handleButtonClick);
    });

    document.addEventListener('click', function(event) {
        const activeContainers = document.querySelectorAll('.product_options__container.active');
        activeContainers.forEach(container => {
            const quickAddParent = container.closest('.quick-add');
            if (quickAddParent && !quickAddParent.contains(event.target)) {
                container.classList.remove('active');
                container.style.top = ''; // Reset the top position
                const quickAddSubmitButton = quickAddParent.querySelector('.quick-add__submit');
                if (quickAddSubmitButton && !quickAddSubmitButton.classList.contains('btn_select_options')) {
                    quickAddSubmitButton.classList.add('btn_select_options');
                    quickAddSubmitButton.addEventListener('click', handleButtonClick);
                }
            }
        });
    });


    document.addEventListener('change', function(event) {
        const target = event.target;
    
        if (target.matches('.product_options__container input[type="radio"]')) {
            const selectedInput = target;
            const form = selectedInput.closest('.quick-add').querySelector('form');
    
            if (selectedInput.value == 'subscription_and_save') {
                const selling_plan = selectedInput.closest('.product_option__subscription').querySelector('.subscription_selling_plan select').value;
                form.querySelector('input[name="selling_plan"]').value = selling_plan;
            } else if (selectedInput.value == 'one_time_purchase') {
                form.querySelector('input[name="selling_plan"]').value = '';
            }
        } else if (target.matches('.subscription_selling_plan select[name="selling_plan"]')) {
            const selectedOption = target.value;
            const form = target.closest('.quick-add').querySelector('form');
            form.querySelector('input[name="selling_plan"]').value = selectedOption;
        }
    });
    
});
